import { Create, useForm } from '@refinedev/antd';

import { ServiceOrder } from '@/model/ServiceOrder/ServiceOrder';

import ServiceOrderForm from './ServiceOrderForm/ServiceOrderForm';

const ServiceOrderCreate = () => {
  const { formProps, saveButtonProps } = useForm<ServiceOrder>({
    successNotification: {
      message: 'Orden de servicio creada correctamente',
      type: 'success',
    },
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <ServiceOrderForm formProps={formProps} />
    </Create>
  );
};

export default ServiceOrderCreate;
